import { useGlobalState } from 'state/globalState'
import { Navigate, Outlet } from 'react-router-dom'

export const AdminRoute = () => {
  const { user } = useGlobalState();

  return ['admin', 'owner'].includes(user?.role || '') ? <Outlet /> : <Navigate to='/' />
}
